import { SolicitacaoAcesso } from "./SolicitacaoAcesso";

export default SolicitacaoAcesso;